module.exports = __webpack_public_path__ + "media/images/pages/home/citizen-science-activities-3-80d3e5b58037be552bef18340c43b184.png";